import styled from 'styled-components';

export const Container = styled.div`
  textarea {
    margin-bottom: 10px;
    display: block;
  }
  select {
    background-color: #f3f7f9;
    width: 100%;
    border: 1px solid #e4eaec;
    color: #a7b3ba;
  }
  .label {
    margin-right: 5px;
  }
  .upload-group {
    .label {
      font-weight: bold;
      display: block;
      margin-top: 7px;
    }
    .secondary-label {
      font-weight: bold;
      color: #aaa;
      display: block;
    }
    .desc {
      font-style: italic;
      font-size: 12px;
      color: #a0a0a0;
      display: block;
      margin-bottom: 10px;
    }
    input[type='file'] {
      margin-bottom: 15px;
    }
  }
  .field-group {
    margin-bottom: 20px;

    .field-title {
      display: block;
      font-weight: bold;
      font-size: 15px;
      margin-bottom: 5px;
    }
    .secondary-title {
      display: block;
      font-weight: bold;
      font-size: 13px;
      color: #333;
    }
    .desc {
      font-style: italic;
      font-size: 12px;
      color: #a0a0a0;
      display: block;
      margin-bottom: 10px;
    }
  }
  .radio-group {
    margin-bottom: 10px;
  }
  .ReactCrop {
    margin-bottom: 15px;
  }
  .ReactCrop__result {
    margin-bottom: 15px;
  }
  .ReactCrop__current-cover {
    width: 100%;
  }
  .react-datepicker-wrapper input {
    margin-bottom: 0;
  }
  .video-react {
    padding-top: 400px !important;
  }
  .card-video {
    height: 400px;
  }
`;

export const ButtonPanel = styled.div`
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EditPost/styles.js